import React, { useState, useRef } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import DropzoneComponent from "react-dropzone-component/dist/react-dropzone";
import Config from "../../commons/config/Config";


const DisponibilidadGridImport = (props) => {
  const [modo, setModo] = useState("default");
  const [loading, setLoading] = useState(false);
  const [hasFile, setHasFile] = useState(false);
  const [archivo, setArchivo] = useState(null);
  const dropzoneRef = useRef(null);

  const fileUploadConfig = {
    showFiletypeIcon: false,
    postUrl: Config.get("apiUrlBase") + "/disponibilidad/importar-excel",
  };

  const eventHandlers = {
    init: (dz) => {
      dropzoneRef.current = dz;
      dz.on("removedfile", () => {
        setHasFile(false);
      });
    },
    addedfile: (file) => {
      setHasFile(true);
      handleUploadFiles(file);
    },
  };

  const handleDownloadFile = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch(Config.get("apiUrlBase") + `/disponibilidad/import-model`, {
        method: "GET",
        headers: {
          "Authorization-Token": localStorage.getItem("token"),
        },
      });
      if (response.status === 200) {
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "Modelo-importacion-disponibilidad.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        props.handleClose();
      } else {
        alert(
          props.intl.formatMessage({
            id: "movilesImportar.error.no_pudo_obtener_documento",
            defaultMessage: "No se pudo obtener el documento",
          }) +
            "\n" +
            props.intl.formatMessage({
              id: "movilesImportar.error.contacte_administrador",
              defaultMessage: "Contacte al Administrador",
            })
        );
      }
    } catch (error) {
      console.error("Error al descargar el archivo:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleUploadFiles = (file) => {
    const dz = dropzoneRef.current;
    if (dz.files.length > 1) {
      dz.removeFile(dz.files[0]);
    }
    setArchivo(file);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    if (dropzoneRef.current) {
      dropzoneRef.current.processQueue();
    } else {
      setLoading(false);
    }
  };

  // Callback tipo resetModal para comunicar resultado al padre
  const resetModal = (message = "", result = null, error = null) => {
    setArchivo(null);
    setHasFile(false);
    setLoading(false);
    if (props.callbackClose) {
      props.callbackClose(message, result, error);
    }
  };
  const handleClose = () => {
    if (dropzoneRef.current) {
      dropzoneRef.current.removeAllFiles(true);
    }
    setArchivo(null);
    setHasFile(false);
    setLoading(false);
    if (props.handleClose) props.handleClose();
  };

  const fileUploadDjsConfig = {
    paramName: "file",
    maxFiles: 2,
    addRemoveLinks: false,
    thumbnailMethod: "crop",
    dictDefaultMessage:
      props.intl.formatMessage({
        id: "movilesImportar.import_file.haga_click_aqui_o",
        defaultMessage: "Haga click aquí o",
      }) +
      "<br>" +
      props.intl.formatMessage({
        id: "movilesImportar.import_file.arrastre_un_archivo_area",
        defaultMessage: "arrastre un archivo a este área",
      }) +
      "<br>" +
      props.intl.formatMessage({
        id: "movilesImportar.import_file.para_cargar_los_datos",
        defaultMessage: "para cargar los datos.",
      }),
    dictInvalidFileType: props.intl.formatMessage({
      id: "movilesImportar.import_file.errors.tipo_archivo_incorrecto",
      defaultMessage: "El tipo de archivo es incorrecto. Solo se permiten .xlsx",
    }),
    dictFileTooBig:
      props.intl.formatMessage({
        id: "movilesImportar.import_file.errors.archivo_muy_grande",
        defaultMessage: "El archivo es muy grande ",
      }) +
      "({{filesize}}MiB)" +
      props.intl.formatMessage({
        id: "movilesImportar.import_file.errors.maximo_permitido",
        defaultMessage: ".Máximo permitido: ",
      }) +
      "{{maxFilesize}}MiB.",
    dictResponseError: "Error interno con código {{statusCode}}.",
    dictCancelUpload: props.intl.formatMessage({
      id: "movilesImportar.import_file.se_cancelo_subida_archivo",
      defaultMessage: "Se canceló la subida del archivo",
    }),
    dictCancelUploadConfirmation: props.intl.formatMessage({
      id: "movilesImportar.import_file.estas_seguro_queres_cancelar_subida",
      defaultMessage: "Estás seguro que querés cancelar la subida?",
    }),
    dictRemoveFile: props.intl.formatMessage({
      id: "movilesImportar.import_file.archivo_eliminado",
      defaultMessage: "Archivo Eliminado",
    }),
    dictRemoveFileConfirmation: null,
    dictMaxFilesExceeded: props.intl.formatMessage({
      id: "movilesImportar.import_file.solo_procesar_un_archivo_por_vez",
      defaultMessage: "Solo se puede procesar un archivo a la vez.",
    }),
    uploadMultiple: false,
    parallelUploads: 1,
      acceptedFiles: ".xlsx,.csv",
    autoProcessQueue: false,
    timeout: 12000000,
    headers: {
      "Authorization-Token": localStorage.getItem("token"),
    },
    params: {
      switch: modo,
    },
    previewTemplate: `
      <div class="dz-preview">
        <div class="dz-image">
          <i class="fa fa-file-excel-o" style="font-size:80px"></i>
        </div>
        <div class="dz-success-mark">✔</div>
        <div class="dz-error-mark">✘</div>
        <div class="dz-error-message"><span data-dz-errormessage></span></div>
      </div>
    `,
    init: function () {
      this.on("success", (archivo, response) => {
        // Cerrar modal principal y mostrar modal de resultado
        const rta = typeof response === "string" ? JSON.parse(response) : response;
        if (rta.invalidos === 0 && (!rta.errores || rta.errores.length === 0)) {
          // Éxito total
          resetModal(
            props.intl.formatMessage({
              id: "disponibilidadImportar.import_file.fue_importado_exito",
              defaultMessage: "El archivo fue importado con éxito",
            }),
            rta,
            { tipo: "success" }
          );
        } else if (Array.isArray(rta.errores) && rta.errores.length > 0) {
          // Errores de importación (reporte)
          resetModal(
            props.intl.formatMessage({
              id: "disponibilidadImportar.import_file.reporte_importacion",
              defaultMessage: "Reporte de la Importación",
            }),
            null,
            { tipo: "reporte", errores: rta.errores }
          );
        } else {
          // Otro error
          resetModal(
            props.intl.formatMessage({
              id: "disponibilidadImportar.errors.error_importar_archivo",
              defaultMessage: "Error al importar el archivo",
            }),
            null,
            { tipo: "error" }
          );
        }
        this.removeFile(archivo);
      });
      this.on("error", (archivo, errormessage, xhr) => {
        // Error técnico, de sesión o tipo de archivo
        let mensaje = (errormessage && errormessage.mensaje) || "";
        let tipoModal = "error";
        if (
          mensaje.includes("Tipo de archivo inválido") ||
          mensaje.includes("tipo de archivo no soportado") ||
          mensaje.includes("El tipo de archivo es incorrecto") ||
          mensaje.includes("Solo se permite .csv") ||
          mensaje.includes("Solo se permiten .xlsx") ||
          mensaje.includes("no es soportado")
        ) {
          mensaje = props.intl.formatMessage({
            id: "disponibilidadImportar.errors.tipo_archivo_no_soportado",
            defaultMessage: "Error al importar el archivo. El tipo de archivo no es soportado."
          });
          tipoModal = "filetype";
        }
        resetModal(
          mensaje || props.intl.formatMessage({
            id: "disponibilidadImportar.errors.error_importar_archivo",
            defaultMessage: "Error al importar el archivo",
          }),
          null,
          { tipo: tipoModal }
        );
        this.removeFile(archivo);
      });
    },
  };

  // Modal principal solo si está abierto
  return (
    <>
      {props.open && (
        <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: 'block' }}>
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header bg-fleet">
                <h4 className="modal-title text-white" id="myModalLabel1">
                  <FormattedMessage id="movilesGrid.tools.import.button.importar" defaultMessage=" Importar" />
                </h4>
                <button type="button" className="close" onClick={handleClose}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body modal-grey">
                <div className="card pull-up">
                  <div className="card-content pl-1 pr-1">
                    <div className="card-body">
                      <h4 className="form-section" style={{ borderBottom: "2px solid #6b6f82", color: "#00c0bd" }}>
                        <i className="la la-file"></i> <FormattedMessage id="disponibilidadGridImport.download.template" defaultMessage="Descargar Modelo" />
                      </h4>
                      <div className="content-body">
                        <button
                          type="button"
                          className="btn btn-primary mr-1 mb-1 col-5"
                          onClick={handleDownloadFile}
                          title="Descargar"
                        >
                          <FormattedMessage id="disponibilidadGridImport.download.template_model" defaultMessage="Planilla Modelo" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card pull-up">
                  <div className="card-content pl-1 pr-1">
                    <div className="card-body">
                      <h4 className="form-section" style={{ borderBottom: "2px solid #6b6f82", color: "#00c0bd" }}>
                        <i className="la la-file"></i>
                        <FormattedMessage id="movilesImportar.import_file.importar_archivo" defaultMessage=" Importar Archivo" />
                      </h4>
                      <div className="row chat-application ml-0 mr-0 mb-1">
                        <div className="content-body">
                          <div className="row mt-1">
                            <div className="col-md-12">
                              <DropzoneComponent
                                id="archivos"
                                config={fileUploadConfig}
                                eventHandlers={eventHandlers}
                                djsConfig={fileUploadDjsConfig}
                              />
                            </div>
                          </div>
                          <hr />
                          <div>
                            {archivo ? (
                              archivo.name
                            ) : (
                              <FormattedMessage id="disponibilidadImportar.import_file.no_hay_archivos_cargados" defaultMessage="No hay archivos cargados." />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <div className="card-footer">
                  <div className="text-cd text-right">
                    <button type="submit" className="btn btn-primary mr-1" onClick={handleSubmit} disabled={!hasFile}>
                      <i className={loading ? "la la-spinner spinner" : "fa fa-check-circle"}></i>
                      <FormattedMessage id="movilesImportar.import_file.button.importar" defaultMessage=" Importar" />
                    </button>
                    <button type="button" className="btn btn-danger" onClick={handleClose}>
                      <i className="fa fa-times-circle"></i>
                      <FormattedMessage id="movilesImportar.import_file.button.cancelar" defaultMessage=" Cancelar" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
  };

export default injectIntl(DisponibilidadGridImport);